import { useSelector } from 'react-redux';
import { RootState } from '../index';
import { topologyTypeSelector } from './selectors';
import { TopologyType } from './types';

/**
 * Funzione di utilità per ottenere il tipo di topologia
 * Può essere usata anche nei saga dove non è possibile usare gli hook
 * @returns Il tipo di topologia (URBAN o HIGHWAY)
 */
export const getTopologyType = (): TopologyType => {
  const topologyType = process.env.TOPOLOGY_TYPE;
  if (topologyType === 'urban') return TopologyType.URBAN;
  if (topologyType === 'highway') return TopologyType.HIGHWAY;
  return TopologyType.HIGHWAY; // Default fallback
};

/**
 * Hook per accedere al tipo di topologia corrente
 * @returns Il tipo di topologia (URBAN o HIGHWAY)
 */
export const useTopologyType = (): TopologyType => {
  return useSelector(topologyTypeSelector);
};

/**
 * Hook per verificare se la topologia corrente è urbana
 * @returns true se la topologia è urbana
 */
export const useIsUrban = (): boolean => {
  const topologyType = useTopologyType();
  return topologyType === TopologyType.URBAN;
};

/**
 * Hook per verificare se la topologia corrente è autostradale
 * @returns true se la topologia è autostradale
 */
export const useIsHighway = (): boolean => {
  const topologyType = useTopologyType();
  return topologyType === TopologyType.HIGHWAY;
};

/**
 * Hook per ottenere configurazioni specifiche per topologia
 * @returns Oggetto con configurazioni per la topologia corrente
 */
export const useTopologyConfig = () => {
  const topologyType = useTopologyType();

  const configs = {
    [TopologyType.URBAN]: {
      defaultZoom: 14,
      pollingRate: process.env.TIME_POLLING_RATE || '10000',
      mapCenter: { lat: 45.502983, lng: 8.96494 },
    },
    [TopologyType.HIGHWAY]: {
      defaultZoom: 12,
      pollingRate: process.env.TIME_POLLING_RATE || '5000',
      mapCenter: { lat: 45.502983, lng: 8.96494 },
    },
  };

  return configs[topologyType];
};
